"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = Bookmark;
var _Bookmark = require("@adobe/react-spectrum-workflow/dist/Bookmark.js");
var _icon = require("@react-spectrum/icon");
var _react = _interopRequireDefault(require("react"));
function Bookmark(props) {
  return /*#__PURE__*/_react.default.createElement(_icon.Icon, props, /*#__PURE__*/_react.default.createElement(_Bookmark.A4uBookmark, null));
}